import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faCircle } from '@fortawesome/free-regular-svg-icons';
import './Answer.scss';

const Answer = props => {
  const { answer, selected, incorrect, letter, showSolution } = props;

  const click = selected ? l => props.deselectAnswer(letter) : l => props.selectAnswer(letter);

  let icon = null;
  if (incorrect && showSolution) {
    icon = faTimesCircle;
  } else if (selected) {
    icon = faCheckCircle;
  } else {
    icon = faCircle;
  }

  let className = 'Answer ';
  if (answer.correcte && showSolution) { className += 'correct '; }
  if (!showSolution) { className += 'selectable '; }
  if (selected) { className += 'selected '; }
  if (incorrect && showSolution) { className += 'incorrect '; }

  return (
    <div className={className} onClick={!showSolution ? click : null}>
      <div className="answer-icon">
        <FontAwesomeIcon icon={icon} className={selected ? 'checked' : ''}/>
      </div>
      <div className="answer-letter">{letter}</div>
      <div className="answer-text">{answer.contenu}</div>
    </div>
  );
};

export default Answer;
